var exports = {
  "cK": "AccessibilityTab.module__previewWrapper___N2dJY2",
  "i1": "AccessibilityTab.module__previewContainer___N2dJY2",
  "Eg": "AccessibilityTab.module__previewActionsRow___N2dJY2",
  "vh": "AccessibilityTab.module__previewAvatarsRow___N2dJY2",
  "R_": "AccessibilityTab.module__previewMessageContainer___N2dJY2",
  "zf": "AccessibilityTab.module__ttsSection___N2dJY2",
  "A6": "AccessibilityTab.module__ttsPreviewRow___N2dJY2",
  "u5": "AccessibilityTab.module__ttsPreviewButton___N2dJY2",
  "MN": "AccessibilityTab.module__ttsPreviewDescription___N2dJY2",
};

module.exports = exports;
